import { indications } from "@/services";

export default {
	namespaced: true,

	state: {
		indicationsData: {},
        detailsData: {},
        indications: [],
	},
	getters: {
		indicationsData(state) {
			return state.indicationsData;
		},
        detailsData(state) {
            return state.detailsData;
        },
        indications(state) {
            return state.detailsData?.indications || [];
        },
	},

	mutations: {
		SET_INDICATIONS_DATA(state, payload) {
			state.indicationsData = payload;
		},
        SET_DETAILS_DATA(state, payload) {
            state.detailsData = payload;
        },
	},
	actions: {
		async setIndicationsData({ commit }, payload ) {
			try {
				const { data } = await indications.get(payload);
				commit("SET_INDICATIONS_DATA", data );
				return data;

			} catch (error) {
				if (error.statusCode && error.message) {
					throw error;
				}
				throw new Error("Não foi possível obter as indicações");
			}
		},
        
        async setDetailsData({ commit }, userId ) {
			try {
				const { data } = await indications.details( userId );
				commit("SET_DETAILS_DATA", data );
				return data;
				
			} catch (error) {
				if (error.statusCode && error.message) {
					throw error;
				}
				throw new Error("Não foi possível obter os detalhes da indicação");
			}
        },
	},
};
